export default "__VITE_ASSET__Z7Bpu$0W__"